import React from 'react';
import { Check } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';

const TierCard = ({ tier, selected, onSelect, showAmc = false }) => {
  const isCustom = tier.price === null || tier.price === undefined;
  const { formatMoney } = useCurrency();
  const priceLabel = isCustom ? 'Custom' : formatMoney(tier.price);

  return (
    <button
      type="button"
      onClick={() => onSelect(tier.id)}
      className={`relative text-left rounded-xl p-5 border transition-all duration-200 group
        ${selected
          ? 'border-emerald-400/60 bg-emerald-400/[0.04] shadow-[0_0_0_1px_rgba(52,211,153,0.35),0_10px_40px_-10px_rgba(52,211,153,0.25)]'
          : 'border-white/10 bg-white/[0.02] hover:border-white/20 hover:bg-white/[0.04]'
        }`}
    >
      {selected && (
        <span className="absolute top-3 right-3 h-5 w-5 rounded-full bg-emerald-400 text-black flex items-center justify-center">
          <Check className="w-3 h-3" strokeWidth={3} />
        </span>
      )}
      {tier.popular && !selected && (
        <span className="absolute -top-2 right-3 text-[9px] tracking-[0.18em] font-semibold uppercase px-2 py-0.5 rounded-full bg-purple-400/90 text-black">
          Most popular
        </span>
      )}
      <div className="text-[10px] tracking-[0.18em] font-semibold uppercase text-white/50">
        {tier.label}
      </div>
      <div className="mt-3 text-xl md:text-[22px] leading-tight font-semibold text-white">
        {tier.name}
      </div>
      <div className="mt-3 flex items-baseline gap-1">
        {isCustom ? (
          <span className="text-emerald-400 text-lg font-semibold">Custom</span>
        ) : (
          <>
            <span className="text-white text-xl font-semibold tracking-tight">
              {priceLabel}
            </span>
            <span className="text-white/50 text-xs">{tier.perLabel || '/mo'}</span>
          </>
        )}
      </div>
      {showAmc && !isCustom && (
        <div className="mt-1 text-[11px] text-white/45">
          + {formatMoney(tier.amcAmount)}/yr AMC
        </div>
      )}
      <p className="mt-3 text-[12.5px] leading-relaxed text-white/55">
        {tier.tagline}
      </p>
    </button>
  );
};

export default TierCard;
